import React from 'react';
import './DeviceSettingModal.css';

const SettingsModal = ({ isOpen, onClose, deviceSettings }) => {
  if (!isOpen) return null;

  return (
    <div className="device-settings-backdrop">
      <div className="device-settings-modal">
        <h2>Device Settings</h2>

        {deviceSettings && deviceSettings.length > 0 ? (
          <div className="settings-content">
            {deviceSettings.map((setting, idx) => (
              <div key={idx} className="setting-row">
                <span className="setting-text">
                   <strong>{setting.name}</strong>: {setting.value}
                </span>
              </div>
            ))}
          </div>
        ) : (
          <p className="no-settings">No settings available for this device</p>
        )}

        <div className="device-settings-actions">
          <button onClick={onClose} className="device-settings-button">
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default SettingsModal;
